/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import AdminForm from "../../components/ui/AdminForm";
import InputIcon from "../../components/form/elements/InputIcon";
import { domainName, isSubjectSubscriptionable } from "../../services/defaultSettings";
import {
    handleCrud,
    handleFormSubmit,
    handleInputChange as handleChange,
    renderInputFields,
} from "../../services/formServices";
import auth from "../../services/authServices";
import http from "../../services/httpServices";
import { submitTypes } from "../../services/adminServices";
import { ReactSortable } from "react-sortablejs";
import LoadingIcon from "../../components/ui/LoadingIcon";
import { years } from "../../services/yearSevices";

const initialState = {
    id: null,
    text: " ",
    titleFirst: " ",
    titleLast: " ",
    teacher_id: 0,
    subject_id: 0,
    year: 3,
    orders: [],
    order: null,
    choosen_year: 3,
    is_selected_by_default: 0,
    choosen_teacher_id: 0,
};

const CategoryEditing = () => {
    const [data, setData] = useState({ ...initialState });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [inputFields, setInputFields] = useState([]);

    const [dataLoaded, setDataLoaded] = useState(false);
    const [categories, setCategories] = useState([]);

    const [teachers, setTeachers] = useState([]);
    const [subjects, setSubjects] = useState([]);

    const getCategories = async (teacher_id, year) => {
        setDataLoaded(false);
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(
            `/api/teachers/${teacher_id}/years/${year}/categories`,
            config
        );
        setCategories(response);
        setDataLoaded(true);
    };

    const getCategoryInfo = () => {
        let category = categories.filter((c) => c.id === data.id && c)[0];
        data["text"] = category.text;
        data["titleFirst"] = category.titleFirst;
        data["titleLast"] = category.titleLast;
        data["teacher_id"] = category.teacher_id;
        data["subject_id"] = category.subject_id;
        data["is_selected_by_default"] = category.is_selected_by_default;
        data["year"] = category.year;
        data["order"] = category.order;
        setData(data);
    };

    const getTeachers = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(`/api/admin/teachers/options`, config);
        setTeachers(response);
    };
    const getSubjects = async () => {
        const token = auth.getAdminToken();
        const config = auth.getAdminAuthConfig(token);

        const { data: response } = await http.get(
            `/api/admin/withyears/teachers/${data.teacher_id}/subjects/options`,
            config
        );
        setSubjects([]);
        setSubjects(response);
    };

    useEffect(() => {
        setData({ ...data, subject_id: 0 });
        if (data.teacher_id > 0 && isSubjectSubscriptionable) {
            getSubjects();
        }
    }, [data.teacher_id]);

    useEffect(() => {
        isSubjectSubscriptionable && getTeachers();
    }, []);

    useEffect(() => {
        if (data.id) {
            getCategoryInfo();
        }
    }, [data.id]);

    const addCurrentCategory = () => {
        console.log(11);
        let tempCategories = [...categories];
        let tempData = { ...data };
        tempData.order = tempCategories.length;
        tempCategories.push(tempData);
        setData(tempData);
        setCategories(tempCategories);
    };

    useEffect(() => {
        if (dataLoaded && data.submit_type === "store") {
            addCurrentCategory();
        }
    }, [dataLoaded, data.submit_type]);

    const afterSort = () => {
        categories.map((c, index) => {
            if (c.id == data.id) {
                let tempData = { ...data };
                tempData.order = index;
                setData(tempData);
            }
        });
    };

    const inputHandler = () => {
        let temp = [...categories];
        temp[data.order] = {
            text: data.titleFirst + " " + data.titleLast,
            titleFirst: data.titleFirst,
            titleLast: data.titleLast,
            id: data.id,
        };
        setCategories(temp);
    };

    useEffect(() => {
        inputHandler();
    }, [data.titleFirst, data.titleLast]);

    useEffect(() => {
        if (data.submit_type === "store") {
            setCategories([]);
            if (data.teacher_id && data.year) {
                getCategories(data.teacher_id, data.year);
            }
        }
        if (data.submit_type === "update") {
            setCategories([]);
            if (data.choosen_teacher_id && data.choosen_year) {
                getCategories(data.choosen_teacher_id, data.choosen_year);
            }
        }
    }, [data.submit_type, data.choosen_teacher_id, data.choosen_year, data.teacher_id, data.year]);

    useEffect(() => {
        let fields = [
            {
                id: "submit_type",
                placeholder: "هتعمل ايه دلوقتي",
                type: "select",
                options: submitTypes,
            },
        ];
        if (data.submit_type) {
            if (data.submit_type && data.submit_type !== "store") {
                fields = [
                    ...fields,
                    {
                        id: "choosen_year",
                        placeholder: "اختر الصف الدراسي",
                        type: "select",
                        options: years,
                    },
                    {
                        id: "choosen_teacher_id",
                        placeholder: "المدرس",
                        options: teachers,
                        type: "select",
                    },
                    {
                        id: "id",
                        placeholder: "اختر الفئة",
                        type: "select",
                        options: categories,
                    },
                ];
            }

            if (
                data.submit_type &&
                (data.submit_type === "store" || (data.submit_type === "update" && data.id))
            ) {
                fields = [
                    ...fields,
                    {
                        id: "year",
                        placeholder: "اختر الصف الدراسي",
                        type: "select",
                        options: years,
                    },
                ];
                if (isSubjectSubscriptionable) {
                    fields = [
                        ...fields,
                        // {
                        //     id: "teacher_id",
                        //     placeholder: "المدرس",
                        //     options: teachers,
                        //     type: "select",
                        // },
                        {
                            id: "subject_id",
                            placeholder: "المادة",
                            options: subjects,
                            type: "select",
                        },
                        // {
                        //     id: "is_selected_by_default",
                        //     placeholder: "اختيارها كفئة افتراضية كفلتر (فى الصفحة الرئيسية)",
                        //     type: "switch",
                        // },
                    ];
                }
                fields = [
                    ...fields,
                    {
                        id: "titleFirst",
                        placeholder: "الاسم الاول",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                    },
                    {
                        id: "titleLast",
                        placeholder: "الاسم الثانى",
                        icon: <InputIcon icon="fluent:app-title-24-filled" />,
                    },
                ];
            }
        }
        setInputFields(fields);
        afterSort();
    }, [categories, data.submit_type, data.id, teachers, subjects]);

    const handleSubmit = (e) => {
        data.orders = JSON.stringify(categories);
        handleFormSubmit(e, setIsLoading, setErrors, () => {
            const adminToken = auth.getAdminToken();
            const config = auth.getAdminAuthConfig(adminToken);
            const crudApiEndPoint = "/api/categories";
            const crudItemName = "فئة";

            handleCrud(
                config,
                data,
                crudApiEndPoint,
                crudItemName,
                setIsLoading,
                setErrors,
                setData,
                initialState,
                data.id
            );
        });
    };
    const sortableOptions = {
        animation: 150,
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        swapThreshold: 0.6,
        invertSwap: true,
    };
    return (
        <AdminContainer>
            <AdminForm
                onSubmit={handleSubmit}
                isLoading={isLoading}
                buttonText="auto"
                submitType={data.submit_type}
            >
                {inputFields.map((input, key) =>
                    renderInputFields(
                        key,
                        input.handleChange ? input.handleChange : handleChange,
                        data,
                        setData,
                        errors,
                        input
                    )
                )}
                {(data.submit_type === "store" && data.teacher_id && data.year) ||
                (data.submit_type === "update" && data.id) ? (
                    <div className="relative">
                        {dataLoaded ? (
                            <>
                                {" "}
                                <span className="mb-10 block">ترتيب الفئه فى الصفحة الرئيسية</span>
                                <ReactSortable
                                    className="space-y-4"
                                    // onSort={onSort}
                                    list={categories}
                                    setList={setCategories}
                                    {...{ ...sortableOptions }}
                                >
                                    {categories.map((c, index) => (
                                        <div
                                            key={index}
                                            className="prevent-select w-full py-3 bg-blue-400 my-2 rounded-md px-3 cursor-pointer duration-200 "
                                        >
                                            {c.text}
                                        </div>
                                    ))}
                                </ReactSortable>
                            </>
                        ) : (
                            <div className="flex w-full justify-center">
                                <span className="mx-3  text-blue-400">
                                    جاري تحميل فئات كورسات الصفحه الرئيسية
                                </span>
                                <LoadingIcon className="text-blue-800 text-xl" />
                            </div>
                        )}
                    </div>
                ) : data.submit_type === "store" || data.submit_type === "update" ? (
                    <div className="relative">
                        <div className="flex w-full justify-center">
                            <span className="mx-3  text-blue-400">
                                يجب اختيار المدرس و السنه الدراسية اولًا لعرض ترتيب الفئات
                            </span>
                            {/* <LoadingIcon className="text-blue-800 text-xl" /> */}
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </AdminForm>
        </AdminContainer>
    );
};

export default CategoryEditing;
